module.exports = __webpack_public_path__ + "static/media/string.9e0ba5df.png";